import { getGuideDisplayName } from "../../../../shared/guideNames.js";
import React, { useState, useMemo, useEffect } from "react";
import { LessonView } from "../Lesson";
import { Breadcrumb } from "../../../../components/BreadCrump";
import {
  BRAND,
  BRAND_DARK,
  BTN_PRIMARY,
  BTN_SECONDARY,
  BUTTON_RESET,
  CARD,
  SURFACE,
  SURFACE_BORDER,
} from "../../../../styles";
import { Badge } from "../../../../components/Badge";
import { isAulaConcluida, isGuiaConcluida } from "../progressUtils";
export function CourseView(props) {
  const guideTarget = props.guideTarget;
  let dados = props.dados;
  let categoria = props.categoria;
  let curso = props.curso;
  let progress = props.progress;
  let studentId = props.studentId;
  let aulaAlvo = props.aulaAlvo;
  let onAulaAlvoAberta = props.onAulaAlvoAberta;
  let onCarregarAulaCompleta = props.onCarregarAulaCompleta;
  let onVoltar = props.onVoltar;
  let onAbrirAula = props.onAbrirAula;
  let onConcluirAula = props.onConcluirAula;
  let onOpenCategoria = props.onOpenCategoria;
  let onHome = props.onHome;
  let onReportarErro = props.onReportarErro;
  let onToggleAula = props.onToggleAula;
  const rowPadding = "clamp(10px, 2.5vw, 16px)";
  const compactMargin = "clamp(10px, 2.8vw, 14px)";
  const [isMobileViewport, setIsMobileViewport] = useState(
    "undefined" !== typeof window && window.innerWidth <= 480,
  );
  const mobileBleedPx = isMobileViewport ? 8 : 0;
  const listHorizontalInset = isMobileViewport ? "clamp(8px, 2.8vw, 12px)" : 0;
  const [aulaAtualId, setAulaAtualIdLocal] = useState(null);
  const setAulaAtualId = (aulaId) => {
    if (aulaId !== null && typeof props.onSelectLesson === "function") {
      props.onSelectLesson({
        cursoId: curso.id,
        aulaId: aulaId,
        type: props.libraryType,
      });
      return;
    }
    setAulaAtualIdLocal(aulaId);
  };
  const [modulosAbertos, setModulosAbertos] = useState({});
  const modulos = useMemo(
    () => dados.modulos.filter((item) => item.curso_id === curso.id),
    [dados.modulos, curso.id],
  );
  const aulas = useMemo(
    () =>
      modulos.flatMap((modulo) =>
        dados.aulas.filter((aula) => aula.modulo_id === modulo.id),
      ),
    [dados.aulas, modulos],
  );
  useEffect(() => {
    const onResize = () => {
      setIsMobileViewport(window.innerWidth <= 480);
    };
    onResize();
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);
  useEffect(() => {
    if (!aulaAlvo || aulaAtualId) return;
    if (aulas.some((item) => item.id === aulaAlvo)) {
      setAulaAtualId(aulaAlvo);
      if (!(null === onToggleAula || undefined === onToggleAula)) {
        onToggleAula(true);
      }
      if (!(null === onAulaAlvoAberta || undefined === onAulaAlvoAberta)) {
        onAulaAlvoAberta();
      }
    }
  }, [aulaAlvo, aulaAtualId, aulas, onAulaAlvoAberta, onToggleAula]);
  const aulaAtual = aulas.find((item) => item.id === aulaAtualId) || null;
  const conteudoAulaCarregado = Boolean(aulaAtual?._contentLoaded);
  useEffect(() => {
    if (
      null !== aulaAtual &&
      undefined !== aulaAtual &&
      aulaAtual.id &&
      !conteudoAulaCarregado &&
      onCarregarAulaCompleta
    ) {
      onCarregarAulaCompleta(aulaAtual.id);
    }
  }, [aulaAtual?.id, conteudoAulaCarregado, onCarregarAulaCompleta]);
  if (aulaAtual) {
    const moduloAtual =
      modulos.find((item) => item.id === aulaAtual.modulo_id) || modulos[0];
    const currentIndex = aulas.findIndex((item) => item.id === aulaAtual.id);
    const anterior = currentIndex > 0 ? aulas[currentIndex - 1] : null;
    const proxima = currentIndex >= 0 ? aulas[currentIndex + 1] : null;
    return (
      <LessonView
        aula={aulaAtual}
        initialGuiaId={
          guideTarget?.aulaId === aulaAtual.id ? guideTarget.guiaId : null
        }
        carregandoConteudo={!conteudoAulaCarregado}
        curso={curso}
        categoria={categoria}
        modulo={moduloAtual}
        progress={progress}
        studentId={studentId}
        onConcluir={(guiaId) => onConcluirAula(aulaAtual.id, guiaId)}
        onVoltar={() => {
          setAulaAtualId(null);
          if (!(null === onToggleAula || undefined === onToggleAula)) {
            onToggleAula(false);
          }
        }}
        onAnterior={anterior ? () => setAulaAtualId(anterior.id) : null}
        onProxima={proxima ? () => setAulaAtualId(proxima.id) : null}
        onOpenCurso={() => {
          setAulaAtualId(null);
          if (!(null === onToggleAula || undefined === onToggleAula)) {
            onToggleAula(false);
          }
        }}
        onOpenCategoria={(catId) => {
          if (!(null === onToggleAula || undefined === onToggleAula)) {
            onToggleAula(false);
          }
          if (!(null === onOpenCategoria || undefined === onOpenCategoria)) {
            onOpenCategoria(catId);
          }
        }}
        onReportarErro={(descricao) =>
          onReportarErro(aulaAtual, moduloAtual, descricao)
        }
        key={aulaAtual.id}
      />
    );
  }
  const concluidas = aulas.filter((item) =>
    isAulaConcluida(progress, item),
  ).length;
  const percentual = aulas.length
    ? Math.round((concluidas / aulas.length) * 100)
    : 0;
  const proximaLivre =
    aulas.find((item) => !isAulaConcluida(progress, item)) || aulas[0] || null;
  return (
    <div
      style={{
        maxWidth: 980,
        margin: "0 auto",
        width: mobileBleedPx
          ? "calc(100% + ".concat(2 * mobileBleedPx, "px)")
          : "100%",
        marginLeft: mobileBleedPx ? -mobileBleedPx : "auto",
        marginRight: mobileBleedPx ? -mobileBleedPx : "auto",
        paddingBottom: "clamp(20px, 5vw, 36px)",
      }}
    >
      <Breadcrumb
        onHome={onHome}
        items={[
          categoria
            ? {
                label: categoria.nome,
                onClick: onOpenCategoria,
              }
            : null,
          {
            label: curso.nome,
          },
        ].filter(Boolean)}
      />
      <div
        style={{
          ...CARD,
          padding: "clamp(12px, 2.8vw, 18px)",
          marginBottom: compactMargin,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "clamp(8px, 2.2vw, 12px)",
            alignItems: "flex-start",
          }}
        >
          <div>
            <div
              style={{
                color: "#64748B",
                fontSize: 12,
                fontWeight: 800,
                marginBottom: 6,
              }}
            >
              {"Conteúdos organizados por módulos"}
            </div>
            <h2
              style={{
                margin: 0,
                color: "#17212B",
                fontSize: 24,
              }}
            >
              {curso.nome}
            </h2>
            {curso.descricao && (
              <p
                style={{
                  margin: "8px 0 0",
                  color: "#526273",
                  fontSize: 13,
                }}
              >
                {curso.descricao}
              </p>
            )}
          </div>
          <div
            style={{
              color: BRAND_DARK,
              fontSize: 20,
              fontWeight: 900,
            }}
          >
            {percentual}
            {"%"}
          </div>
        </div>
        <div
          style={{
            marginTop: compactMargin,
            marginBottom: 8,
            color: "#526273",
            fontSize: 12,
            fontWeight: 700,
          }}
        >
          {concluidas}
          {"/"}
          {aulas.length}
          {" aulas concluídas"}
        </div>
        <div
          style={{
            height: 6,
            background: "#E6EEF2",
            borderRadius: 999,
            overflow: "hidden",
            marginBottom: compactMargin,
          }}
        >
          <div
            style={{
              height: "100%",
              width: "".concat(percentual, "%"),
              background: BRAND,
              borderRadius: 999,
            }}
          />
        </div>
        {proximaLivre && (
          <button
            onClick={() => {
              setAulaAtualId(proximaLivre.id);
              if (!(null === onToggleAula || undefined === onToggleAula)) {
                onToggleAula(true);
              }
            }}
            style={BTN_PRIMARY}
          >
            {0 === percentual
              ? "Começar agora"
              : 100 === percentual
                ? "Revisar curso"
                : "Continuar curso"}
          </button>
        )}
      </div>
      <div
        style={{
          display: "grid",
          gap: "clamp(8px, 2.2vw, 10px)",
          paddingLeft: listHorizontalInset,
          paddingRight: listHorizontalInset,
        }}
      >
        {modulos.map((modulo) => {
          const aulasModulo = dados.aulas.filter(
            (aula) => aula.modulo_id === modulo.id,
          );
          const aberto = modulosAbertos[modulo.id] ?? !modulo.minimizado;
          return (
            <div
              style={{
                borderRadius: 14,
                overflow: "hidden",
                background: SURFACE,
                border: "1px solid ".concat(SURFACE_BORDER),
              }}
              key={modulo.id}
            >
              <button
                onClick={() =>
                  setModulosAbertos((prev) => ({
                    ...prev,
                    [modulo.id]: !aberto,
                  }))
                }
                style={{
                  ...BUTTON_RESET,
                  width: "100%",
                  textAlign: "left",
                  padding: "".concat(rowPadding, " ").concat(rowPadding),
                  background: "rgba(255,255,255,.06)",
                  color: "#FFF",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                    alignItems: "center",
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: 900,
                      }}
                    >
                      {modulo.nome}
                    </div>
                    {modulo.descricao && (
                      <div
                        style={{
                          marginTop: 4,
                          color: "rgba(255,255,255,.58)",
                          fontSize: 12,
                        }}
                      >
                        {modulo.descricao}
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      color: "rgba(255,255,255,.58)",
                      fontSize: 12,
                      fontWeight: 800,
                    }}
                  >
                    {
                      aulasModulo.filter((item) =>
                        isAulaConcluida(progress, item),
                      ).length
                    }
                    {"/"}
                    {aulasModulo.length}
                  </div>
                </div>
              </button>
              {aberto && (
                <div
                  style={{
                    padding: rowPadding,
                    display: "grid",
                    gap: 8,
                  }}
                >
                  {!aulasModulo.length && (
                    <div
                      style={{
                        color: "rgba(255,255,255,.44)",
                        fontSize: 12,
                      }}
                    >
                      {"Nenhuma aula neste módulo."}
                    </div>
                  )}
                  {aulasModulo.map((aula) => {
                    const done = isAulaConcluida(progress, aula);
                    const hasVideo = Boolean(
                      String(aula.videoUrl ?? aula.video_url ?? "").trim(),
                    );
                    const guiaBadges = Array.isArray(aula.guias)
                      ? aula.guias
                          .map((guia) => ({
                            id: guia?.id,
                            nome: String(guia?.nome || "").trim(),
                            concluida: isGuiaConcluida(
                              progress,
                              aula.id,
                              guia?.id,
                            ),
                          }))
                          .filter((guia) => guia.nome)
                      : [];
                    return (
                      <button
                        onClick={() => {
                          setAulaAtualId(aula.id);
                          if (
                            !(null === onAbrirAula || undefined === onAbrirAula)
                          ) {
                            onAbrirAula(aula.id);
                          }
                          if (
                            !(
                              null === onToggleAula ||
                              undefined === onToggleAula
                            )
                          ) {
                            onToggleAula(true);
                          }
                        }}
                        style={{
                          ...BUTTON_RESET,
                          ...CARD,
                          width: "100%",
                          textAlign: "left",
                          padding: rowPadding,
                          border: done
                            ? "1px solid rgba(79,179,169,.46)"
                            : "1px solid transparent",
                        }}
                        key={aula.id}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 12,
                            alignItems: "start",
                          }}
                        >
                          <div
                            style={{
                              minWidth: 0,
                              flex: 1,
                            }}
                          >
                            <div
                              style={{
                                fontSize: 16,
                                fontWeight: 800,
                                color: done ? "#0F766E" : "#18212B",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "wrap",
                              }}
                            >
                              {aula.titulo}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                gap: 6,
                                flexWrap: "wrap",
                                marginTop: 8,
                              }}
                            >
                              {guiaBadges.map((guia, guiaIndex) => (
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 3,
                                    justifyContent: "center",
                                    minHeight: 12,
                                    padding: "2px 6px",
                                    borderRadius: 18,
                                    background: guia.concluida
                                      ? BRAND
                                      : "#F4F7F9",
                                    color: guia.concluida ? "#FFF" : "#526273",
                                    fontSize: 8,
                                    fontWeight: 900,
                                    lineHeight: 1,
                                  }}
                                  key={
                                    guia.id ||
                                    "".concat(aula.id, "-").concat(guiaIndex)
                                  }
                                >
                                  {guia.concluida && (
                                    <span aria-hidden={true}>{"✓"}</span>
                                  )}
                                  {getGuideDisplayName(guia.nome)}
                                </span>
                              ))}
                            </div>
                          </div>
                          {(hasVideo || done) && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: 6,
                                flexWrap: "wrap",
                              }}
                            >
                              {hasVideo && (
                                <Badge color={"#1F4754"}>{"Com video"}</Badge>
                              )}
                              {done && <Badge color={BRAND}>{"OK"}</Badge>}
                            </div>
                          )}
                        </div>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div
        style={{
          marginTop: 14,
          paddingLeft: listHorizontalInset,
          paddingRight: listHorizontalInset,
        }}
      >
        <button onClick={onVoltar} style={BTN_SECONDARY}>
          {"Voltar para disciplinas"}
        </button>
      </div>
    </div>
  );
}
